import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';

import auth from '../auth/reducer';
import logActivityWizard from '../components/schedule-wizard/logActivityReducer';
import clients from './clients';
import activeClient from './activeClient';
import modal from './modal';
import activeUser from './activeUser';
import users from './users';
import entitySearch from './entitySearch';
import globalError from './globalError';
import documentProps from './documentProps';
import mobileNav from './mobileNav';
import theme from './theme';
import tags from './tags';
import dudReasons from './dudReasons';
import sidebar from './sidebar';
import tasks from './tasks';

export default combineReducers({
	routing: routerReducer,
    auth,
    clients,
    activeClient,
    modal,
    activeUser,
    users,
    entitySearch,
    globalError,
    documentProps,
    mobileNav,
    theme,
    tags,
    logActivityWizard,
    dudReasons,
    sidebar,
    tasks
});



// WEBPACK FOOTER //
// ./app/reducers/index.js